import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

interface GalleryCarouselProps {
  hlanguage: any;
  allImagesLink: any;
}

const base_Url = process.env.REACT_APP_BASE_URL;

const GalleryCarousel: React.FC<GalleryCarouselProps> = ({
  hlanguage,
  allImagesLink,
}) => {
  const leftImages = allImagesLink?.["gallery/left"] || [];
  const rightImages = allImagesLink?.["gallery/right"] || [];

  // duplicate for infinite scroll
  const duplicatedLeft = [...leftImages, ...leftImages, ...leftImages];
  const duplicatedRight = [...rightImages, ...rightImages, ...rightImages];

  return (
    <div>
      <div className="py-5 rounded-4" style={{ overflow: "hidden" }}>
        {/* Header */}
        <div className="text-center mb-5">
          <h1
            className="fw-bold"
            style={{
              color: "#1A5319",
              fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
            }}
          >
            {hlanguage?.ourGallery}
          </h1>
          <p
            className="lead text-muted"
            style={{
              color: "#696969",
              fontWeight: "500",
              fontSize: "clamp(1rem, 3vw, 1.4rem)",
            }}
          >
            {hlanguage?.glimplseOfAchi}
          </p>
        </div>

        {/* Row 1 – Left to Right */}
        <div className="mb-4 overflow-hidden">
          <div className="scroll-left-to-right d-flex gap-3">
            {duplicatedLeft.map((img: any, i: number) => (
              <img
                key={`left-${i}`}
                src={`${base_Url}${img.fileUrl}`}
                alt={img.fileName}
                className="img-fluid rounded shadow"
                style={{
                  width: "clamp(160px, 25vw, 350px)",
                  height: "clamp(100px, 15vw, 220px)",
                  objectFit: "cover",
                  flexShrink: 0,
                }}
              />
            ))}
          </div>
        </div>

        {/* Row 2 – Right to Left */}
        <div className="overflow-hidden">
          <div className="scroll-right-to-left d-flex gap-3">
            {duplicatedRight.map((img: any, i: number) => (
              <img
                key={`right-${i}`}
                src={`${base_Url}${img.fileUrl}`}
                alt={img.fileName}
                className="img-fluid rounded shadow"
                style={{
                  width: "clamp(160px, 25vw, 350px)",
                  height: "clamp(100px, 15vw, 220px)",
                  objectFit: "cover",
                  flexShrink: 0,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>
        {`
          @keyframes scroll-left-to-right {
            0% { transform: translateX(-50%); }
            100% { transform: translateX(0%); }
          }

          @keyframes scroll-right-to-left {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }

          .scroll-left-to-right {
            animation: scroll-left-to-right 25s linear infinite;
            width: fit-content;
          }

          .scroll-right-to-left {
            animation: scroll-right-to-left 25s linear infinite;
            width: fit-content;
          }

          .scroll-left-to-right:hover,
          .scroll-right-to-left:hover {
            animation-play-state: paused;
          }

          @media (max-width: 768px) {
            .scroll-left-to-right,
            .scroll-right-to-left {
              animation-duration: 35s;
            }
          }

          @media (max-width: 480px) {
            .scroll-left-to-right,
            .scroll-right-to-left {
              animation-duration: 45s;
            }
          }
        `}
      </style>
    </div>
  );
};

export default GalleryCarousel;
